export const ru = {
    'get-backgrounds-error': 'Произошла ошибка при получении обложек',
    title: 'Выбор обложки',
    'update-error': 'Произошла ошибка при обновлении обложки'
};
